import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import {Studium} from '../model/studium';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-studium',
    templateUrl: './studium.component.html',
    styleUrls: ['./studium.component.css'],
    standalone: false
})
export class StudiumComponent implements OnInit, OnDestroy {

  data: Studium[];
  private studiumData: Subscription;
  loading = true;
  show = true;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.studiumData = this.appService.studiaData
      .subscribe((data) => {
        this.data = data;
        this.loading = false;
      });
    this.appService.fetchStudia();
  }

  ngOnDestroy(): void {
    this.studiumData.unsubscribe();
  }
}
